(function () {
  function applyCollectionViewMode(mode) {
    var root = document.documentElement;
    if (mode !== 'list') {
      mode = 'grid';
    }

    root.setAttribute('data-collection-view', mode);

    var buttons = document.querySelectorAll('[data-grid-view]');
    buttons.forEach(function (btn) {
      var isActive = btn.getAttribute('data-grid-view') === mode;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function bindCollectionViewSwitcher() {
    var buttons = document.querySelectorAll('[data-grid-view]');
    if (!buttons.length) return;

    var saved = 'grid';
    try {
      saved = localStorage.getItem('ga_collection_view') || 'grid';
    } catch (e) {
      saved = 'grid';
    }

    applyCollectionViewMode(saved);

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var mode = btn.getAttribute('data-grid-view') || 'grid';
        applyCollectionViewMode(mode);
        try {
          localStorage.setItem('ga_collection_view', mode);
        } catch (e) {
          // ignore
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCollectionViewSwitcher);
  } else {
    bindCollectionViewSwitcher();
  }
})();
